import React, { useState, useEffect } from 'react';
import { Button, Card, Form, ListGroup } from "react-bootstrap";
import { postCarmessages, getCarmessages } from "../../services/auth.api";
import Loader from "../Loader/loader.components";
import "./Clientaction.styles.css";

interface ClientActionProps {
  activities: any[];
  sidebyside: boolean;
  isLoading: boolean;
  message: string;
  setmessage: (data: string) => void;
  handleSubmitMessage: (e: React.FormEvent) => void;
}

const ClientAction: React.FC<ClientActionProps> = ({ activities, sidebyside, isLoading, message, setmessage, handleSubmitMessage }) => {  

  const handleMessageChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setmessage(event.target.value);
  };

  return (
    <Card className="" style={{ backgroundColor: "transparent", border: "none" }}>
      <div className={sidebyside ? "d-flex flex-column flex-md-row justify-content-between" : ""}>
        <div className={sidebyside ? "mb-4 mb-md-0" : ""} style={sidebyside ? { width: "100%", maxWidth: "48%" } : {}}>
          <p className="new-message-sublabel">
          Client must complete this section.
          </p>
          <p className="new-message-sublabel-dec">Describe the action(s) taken to resolve this nonconformance/observation and prevent reoccurrence</p>
          <Form onSubmit={handleSubmitMessage}>
            <Form.Group controlId="newMessage">
              <Form.Control
                as="textarea"
                rows={6}
                placeholder="Add text..."
                className="new-message-textarea"
                value={message}
                onChange={handleMessageChange}
              />
            </Form.Group>
            <div className="d-flex justify-content-end mt-3">
              <Button
                variant="success"
                className="px-5 py-2 rounded-pill submit-btn"
                type="submit"
                disabled={message.length === 0}
              >
                Submit
              </Button>
            </div>
          </Form>
        </div>
        <div style={sidebyside ? { width: "100%", maxWidth: "48%" } : {}} className="mt-5">
          <div className="activity-container">
            <h3 className="activity-title">Activity</h3>
            <div className="activity-timeline">
              <div className="timeline-line"></div>

              <ListGroup className="activityContent">
                {activities.map((activity, index) => (
                  <div key={activity.id} className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}>
                    <span className="timeline-point"></span>
                    <ListGroup.Item className="activityUser-heading-action">
                      <strong>{activity.Message_Shared_By__c.replace(/^Auditor:\s*/, "")}</strong>
                      <span className="activity-timestamp">
                        {new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric" }).format(new Date(activity.LastModifiedDate))}
                      </span>
                      {activity.Message_Body__c && (
                        <p
                          className="activity-heading-sublabel"
                          dangerouslySetInnerHTML={{
                            __html: new DOMParser()
                              .parseFromString(activity.Message_Body__c, "text/html")
                              .documentElement.textContent // Decodes all entities safely
                              ?.replace(/“|”/g, '"') // Convert fancy quotes to standard quotes
                              ?.replace(/‘|’/g, "'") || "", // Convert fancy apostrophes to standard
                          }}
                        ></p>

                      )}
                    </ListGroup.Item>
                  </div>
                ))}
              </ListGroup>

            </div>
          </div>

        </div>
      </div>
    </Card>
  );
};

export default ClientAction;
